import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/translations/messages'
import localStorageUtil from '@/utils/localStorageUtil'

Vue.use(VueI18n)

if (localStorageUtil.getTranslations()) {
  messages.en = Object.assign(messages.en, localStorageUtil.getTranslations())
}

const i18n = new VueI18n({ locale: 'en', messages })

export default i18n



// WEBPACK FOOTER //
// ./src/translations/index.js